/**
 * Coach-mark anchor keys (workbook v2.38) for the saved-Plan, edit-Plan and favourite-Plan lessons
 * of FLIP-386. Kept free of imports so components, cards and the lesson services can all name an
 * anchor without pulling each other in (the expanded-card view and CardExpandService would
 * otherwise import each other through the lesson service).
 */

/** UP02: an Activity Card on the saved Plan. */
export const UP02_ANCHOR = "plan.activity_card";
/** UP03: the active (expanded) stack. */
export const UP03_ANCHOR = "plan.expanded_stack";
/** UP04: the bottom-right expand icon of a card in the active stack. */
export const UP04_ANCHOR = "plan.card_expand";
/** UP05: the flip icon on the expanded card - present only when the card has a back. */
export const UP05_ANCHOR = "plan.card_flip";
/** UP06: the eye icon above a day section. */
export const UP06_ANCHOR = "plan.section_visibility";
/** UP07A-F (workbook v2.47): one anchor per control of the view-mode toolbar. */
export const UP07A_ANCHOR = "plan.view_toolbar_back";
export const UP07B_ANCHOR = "plan.view_toolbar_favourite";
export const UP07C_ANCHOR = "plan.view_toolbar_zoom";
export const UP07D_ANCHOR = "plan.view_toolbar_edit";
export const UP07E_ANCHOR = "plan.view_toolbar_reuse";
export const UP07F_ANCHOR = "plan.view_toolbar_delete";
/**
 * UP08: the Favourite Plan control in the view-mode toolbar - the workbook's plan.favourite_control. It
 * is the same element as UP07B's, and an element carries one anchor key, so it is registered once, as
 * UP07B_ANCHOR, and UP08 resolves it through that key.
 */
export const UP08_ANCHOR = UP07B_ANCHOR;
/** EP01: the edit-mode toolbar. */
export const EP01_ANCHOR = "plan.edit_toolbar";
/** FP01: the Favourite Plans section of the Plan landing page. */
export const FP01_ANCHOR = "plan.favourite_plans";
/** FP02: the View all control of the Favourite Plans section. */
export const FP02_ANCHOR = "plan.favourite_plans_view_all";
